export const habaCountryPopup = {
  countryPopup: {
    retainCountry: 'In this shop only deliveries to {{country}} are possible',
    changeCountry: 'For orders with a different delivery address, please select another country.',
    buttonRetain: 'Retain country',
    buttonChange: 'Confirm change',
    countryLabel: 'Choose country',
    languageLabel:'Language',
    infoText: 'Your shopping cart will be emptied when you change your country.'
  }
};